import styled from "styled-components";
import {
  COLORS,
  responsive,
  tabletAboveRange,
} from "../../../../../../../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../../../../../../../components/typography/MuiTypography.style";

export const ProjectCreateActivityWrapper = styled.div`
  .MuiTabs-flexContainer {
    border-bottom: 5px solid ${COLORS.cirrus_black3};
  }

  .MuiGrid2-root {
    padding-right: 18px;
    margin-top: 40px;

    &:nth-child(-n + 3) {
      margin-top: 0px;
    }
    ${responsive.TABLET_LANDSCAPE`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 0px;
      }
      &:nth-child(3) {
        margin-top: 40px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}
    ${tabletAboveRange`
      &:nth-child(3) {
        margin-top: 40px;
      }
    `}
    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 0px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
        }
    `}
  }

  .MuiGrid2-container {
    padding-right: 0px;
  }

  .activity-tab-general,
  .activity-tab-default {
    padding: 24px 0px 0px 16px;
    ${responsive.MOBILE`
      padding: 0 0 0 16px;
    `}
  }

  .exception-heading,
  .select-applicable {
    color: ${COLORS.cirrus_black10};
    border-top: 1px dotted ${COLORS.primary_light_blue4};
    margin-top: 24px;
    padding: 24px 16px 0px;
    ${responsive.MOBILE`
      margin-top: 0;
      padding: 16px 0 0 16px;
    `}
  }

  .checkbox-container {
    display: flex;
    padding: 24px 16px;
    ${responsive.MOBILE`
      padding: 16px 16px;
    `}
  }

  .topic-name {
    background-color: ${COLORS.cirrus_white};
    position: relative;
  }

  .topic-manage-locale-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }

  .exception-form-container {
    padding: 24px 16px;

    .add-button {
      margin-top: 30px;
    }
  }

  .table-container {
    padding: 24px 16px;
  }
`;
